import React from 'react';
import { createValidationErrors, Validation } from 'ui';
import { DebounceTextarea } from 'ui/common/debounce-textarea/debounce-textarea';
import { routeConstants } from 'app/routes/route-constants';
import { Value } from 'app/types-shared';
import * as navigate from 'app/area/shared/navigation';

import { maxLengthText } from '../../../constants';
import { TextSearchData } from '../types-store';
import { TextListItem } from './types';
import { getTextDataId } from './get-text-data-id';
import { itemPropsAreEqual } from './item-props-are-equal';

import styles from './text-list-row.scss';

const getDescription = (value: Value) => value ? value.d : undefined;

const hideRepeatingText = (text: string | number, previousText: string | number) =>
  text !== undefined && text.toString().trim() !== '' && text !== previousText
    ? text
    : undefined;

const hideRepeatingValue = (value: Value, previousValue: Value) =>
  hideRepeatingText(
    getDescription(value),
    getDescription(previousValue)
  );

export const TextListRow: TextListItem = React.memo(({
  textData = {} as TextSearchData, previousTextData = {} as TextSearchData,
  modifiedText, modifyText, edited, validationMessages
}) => {

  const idValue = hideRepeatingText(textData.id, previousTextData.id);
  const textSetValue = idValue === undefined
    ? hideRepeatingValue(textData.textSet, previousTextData.textSet)
    : getDescription(textData.textSet);
  const languageValue = textSetValue === undefined
    ? hideRepeatingValue(textData.language, previousTextData.language)
    : getDescription(textData.language);

  const onClick = () => {
    navigate.to(routeConstants.textConfigurationItemFor(textData.id, textData.textSet?.v));
  };

  const hasErrors = (validationMessages?.length ?? 0) > 0;
  const validation = hasErrors ? createValidationErrors(validationMessages) : undefined;

  return <tr className={hasErrors ? `has-danger ${styles.error}` :
    edited ? styles.edited : undefined}>
    <td onClick={onClick}>{idValue}</td>
    <td onClick={onClick}>{textSetValue}</td>
    <td onClick={onClick}>{languageValue}</td>
    <td onClick={onClick}>{textData.originalText}</td>
    <td>
      <DebounceTextarea
        className={undefined}
        id={`text_${getTextDataId(textData)}`}
        value={modifiedText !== undefined ? modifiedText : textData.text}
        onChange={modifyText}
        maxLength={maxLengthText}
        wait={500} />
      {hasErrors && <Validation level={validation.level} messages={validation.messages} />}
    </td>
  </tr>;
}, itemPropsAreEqual);
